import { defineComponent as _defineComponent } from 'vue'
import pdf from "vue-pdf";
import ScaleOut from "@/components/scale-out-component.vue";
import { computed, ref } from "vue";
import Examination from "@/interfaces/examination.interface";
import { useShowErrorMessage } from "@/composables/use-notifications";
import CourseWork from "@/interfaces/courseWork.interface";


export default /*#__PURE__*/_defineComponent({
  __name: 'document-content',
  props: {
    assessment: null,
    type: null
  },
  setup(__props: any) {

const props = __props as {
  assessment?: Examination | CourseWork | null;
  type: "questionPaper" | "answerSheet";
}



const activePage = ref(1);
const isLoading = ref(true);
const progress = ref(0);
const totalPages = ref("N/A");

const documentTypeFormatted = computed((): string =>
  props.type == "questionPaper" ? "Question Paper" : "Answer Sheet"
);

const downloadProgress = computed(() => {
  return Math.round(progress.value * 100);
});

const fileExtension = computed((): string | undefined => {
  if (props.type == "questionPaper") {
    if (props.assessment?.question_paper_path_key) {
      return props.assessment.question_paper_path_key.split(".").pop();
    }
    return "";
  } else if (props.assessment?.answer_sheet_path_key) {
    return props.assessment.answer_sheet_path_key.split(".").pop();
  } else {
    return "";
  }
});

const fileURL = computed(() => {
  return props.type == "questionPaper"
    ? props.assessment?.question_paper_path_url
    : props.assessment?.answer_sheet_path_url;
});

const onLoaded = () => {
  isLoading.value = false;
};
const onProgress = (value: number) => {
  if (!value) return;
  progress.value = value;
};

const onPDfError = () => {
  useShowErrorMessage(
    "loading Failed",
    "Unable to load the selected Document, please try again"
  );
  // this.$router.back();
};

const onNextPage = () => {
  if (activePage.value == +totalPages.value) return;
  ++activePage.value;
  window.scrollTo(0, 0);
};

const onPreviousPage = () => {
  if (activePage.value == 1) return;
  --activePage.value;
  window.scrollTo(0, 0);
};

const onPageNumberObtained = (pageNumber: number) => {
  totalPages.value = `${pageNumber}`;
};

return { __sfc: true,props, activePage, isLoading, progress, totalPages, documentTypeFormatted, downloadProgress, fileExtension, fileURL, onLoaded, onProgress, onPDfError, onNextPage, onPreviousPage, onPageNumberObtained, pdf, ScaleOut }
}

})